import { createApp } from 'vue';
import App from './App.vue';
import './registerServiceWorker';

const app = createApp(App);

// store
import store from './store';
app.use(store);

// router
import router from './router';
app.use(router);

// axios
import axios from 'axios';
import VueAxios from 'vue-axios';
app.use(VueAxios, axios);

// vant
import { Button, Empty, Overlay, VanImage } from "./vant";
app.use(Button);
app.use(Empty);
app.use(Overlay);
app.use(VanImage);

// vue3-popper
import Popper from "vue3-popper";
app.use(Popper);

// 自定义
import Loading from './components/loading/loading.vue';
import Decorate from './components/decorate/decorate.vue';
import "./assets/styles/base.less";
import { formatImage } from './assets/utils/pipe';
app.component('loading', Loading);
app.component('decorate', Decorate);

app.config.globalProperties.$filters = {
  formatImage
};

app.mount('#app');